<template>
  <div id="app">
    <app-nav-bar id="app-nav-bar" v-if="navVisible"></app-nav-bar>
    <router-view id="router-view"></router-view>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AppNavBar from "@/components/nav-bar";
export default {
  components: {
    AppNavBar
  },
  computed: {
    ...mapGetters(["navVisible"])
  }
};
</script>
<style lang="scss">
@import "@/assets/styles/app";
</style>
